
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'pricing-pages-ui',
  currentProjectVersion: 'static-1.39254',
  depVersions: {
  "pricing-pages-ui": "static-1.39254",
  "apollo-dlb": "static-3.41",
  "client-types": "static-1.374",
  "data-fetching-client": "static-1.8473",
  "demographics-service-types": "static-1.706",
  "eligibility-engine-service-types": "static-1.2238",
  "feature-store-service-types": "static-1.3549",
  "foundations-assets": "static-1.3785",
  "graphql": "static-1.59",
  "growth-monetization-service-types": "static-1.3556",
  "head-dlb": "static-1.4043",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6870",
  "hub-http": "static-1.4807",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10361",
  "I18n": "static-7.1393",
  "jasmine": "static-4.3205",
  "jasmine-runner": "static-1.5263",
  "laboratory-lib": "static-3.6112",
  "personalization-service-types": "static-1.2059",
  "pricing-pages-api": "static-1.8148",
  "pricing-pages-lib": "static-1.28965",
  "purchase-motions-components": "static-1.4027",
  "quartz": "static-1.5619",
  "react-dlb": "static-1.53",
  "react-rhumb": "static-1.15441",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.3575",
  "sanitize-text": "static-1.7034",
  "self-service-api": "static-1.9068",
  "signup-constants": "static-1.16391",
  "styled-components": "static-2.64",
  "trials-service-types": "static-1.2957",
  "ui-addon-upgrades": "static-9.16103",
  "upgrade-management-service-types": "static-1.3540",
  "usage-tracker-container": "static-1.6326",
  "webpack-env": "static-1.54",
  "account-and-billing-fintech-outages": "static-3.15433",
  "copilot-toolkit": "static-1.6673",
  "demographics-client": "static-1.4268",
  "enviro": "static-4.306",
  "foundations-components": "static-1.6071",
  "foundations-theming": "static-1-rd-fix-namespaceplugin.53",
  "growth-payments-core": "static-1.21389",
  "hubspot-url-utils": "static-1.3063",
  "js-cookie": "static-1.18",
  "metrics-js": "static-1.8459",
  "onboarding-scopes": "static-1.5423",
  "payments-enrollment-embed-lib": "static-1.17985",
  "PortalIdParser": "static-2.284",
  "prefetcher": "static-1.4636",
  "pricing-pages-ui-components": "static-1.8286",
  "quartz-core": "static-1.4838",
  "quick-fetch": "static-1.2772",
  "raven": "static-3.4818",
  "react": "static-7.151",
  "react-redux": "static-7.16",
  "react-utils": "static-2.4371",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "SharedI18nStrings": "static-1.162",
  "signup-ui-url-generator": "static-2.6921",
  "touchless-buying-components": "static-1.3439",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.11013",
  "ui-addon-i18n": "static-1.9783",
  "ui-addon-iframeable": "static-1.7755",
  "ui-addon-react-router-dom": "static-1.8470",
  "ui-addon-video-player": "static-1.7631",
  "UIComponents": "static-3.7308",
  "usage-tracker-core": "static-1.6186",
  "usage-tracker-multi": "static-1.4750",
  "apollo-stack-hubspot": "static-3.43",
  "hs-promise-rejection-tracking": "static-1.4356",
  "raven-hubspot": "static-1.5125",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "bend-plugin-trellis-migration": "static-1.2503",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1896",
  "quartz-webpack": "static-1.1843",
  "msw": "static-1.39",
  "ts-schema": "static-1.3183",
  "hs-story-utils": "static-1.8251",
  "HeadJS": "static-2.579",
  "framer-motion": "static-1.41",
  "hs-test-utils-bend-plugin": "static-1.1981",
  "testing-library": "static-1.121",
  "i18n-data": "static-1.198",
  "moment-timezone": "static-5.51",
  "superstore": "static-1.3634",
  "marketing-contacts-client": "static-1.6496",
  "nav-client-types": "static-1.1200",
  "purchase-motions-api": "static-1.4029",
  "usage-tracker": "static-1.6336",
  "quartz-core-utils": "static-1.2486",
  "StyleGuideUI": "static-3.463",
  "autolinker": "static-3.11",
  "sanitize": "static-1.3247",
  "csstype": "static-1.38",
  "atom": "static-1.4062",
  "cssUtils": "static-1.505",
  "HubStyle": "static-2.10669",
  "icons": "static-2.592",
  "react-input-autosize": "static-2.17",
  "salesImages": "static-1.501",
  "chatspot-client-types": "static-1.8700",
  "chatspot-core": "static-1.15912",
  "bend-plugin-foundations-components": "static-1.2340",
  "floating-ui": "static-1.29",
  "foundations-theming-specialty": "static-1-rd-fix-namespaceplugin.53",
  "react-aria": "static-1.39",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.74",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.332",
  "ui-images": "static-2.857",
  "bend-plugin-foundations-theming": "static-1-rd-fix-namespaceplugin.53",
  "foundations-theming-base": "static-1-rd-fix-namespaceplugin.53",
  "commerce-analytics-service-client": "static-1.2568",
  "frontend-preferences-client": "static-1.6731",
  "hs-lodash": "static-4.45",
  "ui-addon-opt": "static-4.7491",
  "crm_data": "static-4.87029",
  "customer-data-objects-ui-components": "static-1.11754",
  "growth-onboarding-confetti": "static-1.1962",
  "growth-onboarding-feedback-components": "static-1.5312",
  "growth-onboarding-reliability": "static-1.4017",
  "marketplace-ui-apps-core": "static-1.13151",
  "onboarding-tours": "static-1.14475",
  "stripe-embedded-components": "static-1.5348",
  "storybook-react": "static-1.4",
  "dispatcher": "static-1.113",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.651",
  "hub-http-shared-msw-handlers": "static-1.7137",
  "hubspotter-http": "static-1.3631",
  "hubspotter-http-shared-msw-handlers": "static-1.7135",
  "mobile-manifest-mixins": "static-1.350",
  "platform-navigation-bootstrap": "static-1.11277",
  "immer": "static-1.33",
  "checkout-sdk": "static-3.21218",
  "checkout-service-types": "static-1.2965",
  "company-details-components": "static-1.4784",
  "emoji-regex": "static-1.7",
  "foundations-components-test-utils": "static-1.3556",
  "payment-method-components": "static-1.5450",
  "upgrade-catalog-service-types": "static-1.2670",
  "ai-components-ui-library": "static-1.5326",
  "hs-promise-utils": "static-1.4386",
  "hubs-service-types": "static-1.328",
  "user-context": "static-1.4037",
  "magpie-lib": "static-1.4529",
  "navigation-messaging": "static-1.3331",
  "usage-tracker-anonymous": "static-1.4753",
  "usage-tracker-public": "static-1.6147",
  "sassPrefix": "static-1.131",
  "feedback-loader": "static-1.26654",
  "crm_schema": "static-3.87067",
  "crm_universal": "static-1.20617",
  "customer-data-email": "static-1.15876",
  "customer-data-objects": "static-1.6485",
  "customer-data-ui-utilities": "static-1.8584",
  "native-integrations-shared-strings": "static-1.6699",
  "property-translator": "static-1.4258",
  "avatar-components": "static-1.1300",
  "react-immutable-proptypes": "static-2.8",
  "reference-resolvers": "static-1.7022",
  "ui-addon-avatars": "static-2.8157",
  "developer-experience-shared-components": "static-1.9035",
  "immutable-less": "static-1.3415",
  "marketplace-ui-client-types": "static-1.12022",
  "marketplace-ui-common": "static-1.14615",
  "ui-addon-integrations-directory-panel": "static-2.6855",
  "ui-extensibility-client-types": "static-1.3015",
  "ui-universal-auth": "static-1.7660",
  "getting-started-shared-tasks": "static-1.12990",
  "growth-data-modal": "static-1.4087",
  "navigation-components": "static-1.14004",
  "ui-shepherd-react": "static-3.8925",
  "ui-shepherd-tracker": "static-1.6306",
  "stripe-connect-js": "static-1.40",
  "platform-infra-nav-components": "static-1.6742",
  "hub-http-rxjs": "static-1.618",
  "normalizr": "static-3.9",
  "PatternValidationJS": "static-1.437",
  "ramda": "static-1.7",
  "rxjs": "static-5.10",
  "company-details-service-types": "static-1.2782",
  "final-form": "static-1.40",
  "billing-payments-client-types": "static-1.2851",
  "ContentUtils": "static-1.63533",
  "getting-started-shared-tasks-store": "static-1.12108",
  "idb-keyval": "static-1.21",
  "magpie-types": "static-1.3989",
  "simple-logging-lib": "static-1.1900",
  "FormUrlGenerator": "static-2.3582",
  "apollo-link-hub-http": "static-2.3639",
  "FileManagerCore": "static-1.34418",
  "FileManagerLib": "static-1.34559",
  "hubspot-apollo-client": "static-1.3686",
  "react-immutable-render-mixin": "static-1.9",
  "timezone-utils": "static-2.4103",
  "ui-gdpr-components": "static-1.9102",
  "react-dnd-compat": "static-1.3519",
  "apps-service-types": "static-1.2952",
  "oauth-service-types": "static-1.3156",
  "ai-settings-ui-library": "static-1.5996",
  "nav-meta": "static-1.25641",
  "react-window": "static-1.13",
  "cms-field-types": "static-1.3651",
  "content-icons-ui": "static-1.1917",
  "underscore": "static-1.8",
  "audio-components": "static-1.4524",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.18918",
  "FileManagerImages": "static-1.32069",
  "urlinator": "static-1.3412",
  "video-components": "static-1.8191",
  "video-data-lib": "static-1.29840",
  "video-embed": "static-1.30680",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "content-assistance-lib": "static-1.6366",
  "media-bridge-lib": "static-1.16811",
  "immerable": "static-1.3010",
  "social-insights-client-types": "static-1.17945",
  "outpost": "static-1.3217",
  "react-transition-group": "static-1.7",
  "ui-coaching-tips": "static-1.23294"
},
  depPathPrefixes: {
  "pricing-pages-ui": "/pricing-pages-ui/static-1.39254",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "client-types": "/client-types/static-1.374",
  "data-fetching-client": "/data-fetching-client/static-1.8473",
  "demographics-service-types": "/demographics-service-types/static-1.706",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2238",
  "feature-store-service-types": "/feature-store-service-types/static-1.3549",
  "foundations-assets": "/foundations-assets/static-1.3785",
  "graphql": "/graphql/static-1.59",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3556",
  "head-dlb": "/head-dlb/static-1.4043",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6870",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10361",
  "I18n": "/I18n/static-7.1393",
  "jasmine": "/jasmine/static-4.3205",
  "jasmine-runner": "/jasmine-runner/static-1.5263",
  "laboratory-lib": "/laboratory-lib/static-3.6112",
  "personalization-service-types": "/personalization-service-types/static-1.2059",
  "pricing-pages-api": "/pricing-pages-api/static-1.8148",
  "pricing-pages-lib": "/pricing-pages-lib/static-1.28965",
  "purchase-motions-components": "/purchase-motions-components/static-1.4027",
  "quartz": "/quartz/static-1.5619",
  "react-dlb": "/react-dlb/static-1.53",
  "react-rhumb": "/react-rhumb/static-1.15441",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.3575",
  "sanitize-text": "/sanitize-text/static-1.7034",
  "self-service-api": "/self-service-api/static-1.9068",
  "signup-constants": "/signup-constants/static-1.16391",
  "styled-components": "/styled-components/static-2.64",
  "trials-service-types": "/trials-service-types/static-1.2957",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16103",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3540",
  "usage-tracker-container": "/usage-tracker-container/static-1.6326",
  "webpack-env": "/webpack-env/static-1.54",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15433",
  "copilot-toolkit": "/copilot-toolkit/static-1.6673",
  "demographics-client": "/demographics-client/static-1.4268",
  "enviro": "/enviro/static-4.306",
  "foundations-components": "/foundations-components/static-1.6071",
  "foundations-theming": "/foundations-theming/static-1-rd-fix-namespaceplugin.53",
  "growth-payments-core": "/growth-payments-core/static-1.21389",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "js-cookie": "/js-cookie/static-1.18",
  "metrics-js": "/metrics-js/static-1.8459",
  "onboarding-scopes": "/onboarding-scopes/static-1.5423",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17985",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "prefetcher": "/prefetcher/static-1.4636",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.8286",
  "quartz-core": "/quartz-core/static-1.4838",
  "quick-fetch": "/quick-fetch/static-1.2772",
  "raven": "/raven/static-3.4818",
  "react": "/react/static-7.151",
  "react-redux": "/react-redux/static-7.16",
  "react-utils": "/react-utils/static-2.4371",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6921",
  "touchless-buying-components": "/touchless-buying-components/static-1.3439",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.11013",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9783",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7755",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8470",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7631",
  "UIComponents": "/UIComponents/static-3.7308",
  "usage-tracker-core": "/usage-tracker-core/static-1.6186",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4750",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
  "raven-hubspot": "/raven-hubspot/static-1.5125",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2503",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1896",
  "quartz-webpack": "/quartz-webpack/static-1.1843",
  "msw": "/msw/static-1.39",
  "ts-schema": "/ts-schema/static-1.3183",
  "hs-story-utils": "/hs-story-utils/static-1.8251",
  "HeadJS": "/HeadJS/static-2.579",
  "framer-motion": "/framer-motion/static-1.41",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1981",
  "testing-library": "/testing-library/static-1.121",
  "i18n-data": "/i18n-data/static-1.198",
  "moment-timezone": "/moment-timezone/static-5.51",
  "superstore": "/superstore/static-1.3634",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.6496",
  "nav-client-types": "/nav-client-types/static-1.1200",
  "purchase-motions-api": "/purchase-motions-api/static-1.4029",
  "usage-tracker": "/usage-tracker/static-1.6336",
  "quartz-core-utils": "/quartz-core-utils/static-1.2486",
  "StyleGuideUI": "/StyleGuideUI/static-3.463",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.3247",
  "csstype": "/csstype/static-1.38",
  "atom": "/atom/static-1.4062",
  "cssUtils": "/cssUtils/static-1.505",
  "HubStyle": "/HubStyle/static-2.10669",
  "icons": "/icons/static-2.592",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "salesImages": "/salesImages/static-1.501",
  "chatspot-client-types": "/chatspot-client-types/static-1.8700",
  "chatspot-core": "/chatspot-core/static-1.15912",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2340",
  "floating-ui": "/floating-ui/static-1.29",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1-rd-fix-namespaceplugin.53",
  "react-aria": "/react-aria/static-1.39",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.74",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.332",
  "ui-images": "/ui-images/static-2.857",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1-rd-fix-namespaceplugin.53",
  "foundations-theming-base": "/foundations-theming-base/static-1-rd-fix-namespaceplugin.53",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2568",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6731",
  "hs-lodash": "/hs-lodash/static-4.45",
  "ui-addon-opt": "/ui-addon-opt/static-4.7491",
  "crm_data": "/crm_data/static-4.87029",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11754",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1962",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5312",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4017",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.13151",
  "onboarding-tours": "/onboarding-tours/static-1.14475",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5348",
  "storybook-react": "/storybook-react/static-1.4",
  "dispatcher": "/dispatcher/static-1.113",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.651",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7137",
  "hubspotter-http": "/hubspotter-http/static-1.3631",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7135",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.350",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11277",
  "immer": "/immer/static-1.33",
  "checkout-sdk": "/checkout-sdk/static-3.21218",
  "checkout-service-types": "/checkout-service-types/static-1.2965",
  "company-details-components": "/company-details-components/static-1.4784",
  "emoji-regex": "/emoji-regex/static-1.7",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3556",
  "payment-method-components": "/payment-method-components/static-1.5450",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2670",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5326",
  "hs-promise-utils": "/hs-promise-utils/static-1.4386",
  "hubs-service-types": "/hubs-service-types/static-1.328",
  "user-context": "/user-context/static-1.4037",
  "magpie-lib": "/magpie-lib/static-1.4529",
  "navigation-messaging": "/navigation-messaging/static-1.3331",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4753",
  "usage-tracker-public": "/usage-tracker-public/static-1.6147",
  "sassPrefix": "/sassPrefix/static-1.131",
  "feedback-loader": "/feedback-loader/static-1.26654",
  "crm_schema": "/crm_schema/static-3.87067",
  "crm_universal": "/crm_universal/static-1.20617",
  "customer-data-email": "/customer-data-email/static-1.15876",
  "customer-data-objects": "/customer-data-objects/static-1.6485",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8584",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6699",
  "property-translator": "/property-translator/static-1.4258",
  "avatar-components": "/avatar-components/static-1.1300",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reference-resolvers": "/reference-resolvers/static-1.7022",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9035",
  "immutable-less": "/immutable-less/static-1.3415",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.12022",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.14615",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6855",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3015",
  "ui-universal-auth": "/ui-universal-auth/static-1.7660",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12990",
  "growth-data-modal": "/growth-data-modal/static-1.4087",
  "navigation-components": "/navigation-components/static-1.14004",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8925",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6306",
  "stripe-connect-js": "/stripe-connect-js/static-1.40",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6742",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.618",
  "normalizr": "/normalizr/static-3.9",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ramda": "/ramda/static-1.7",
  "rxjs": "/rxjs/static-5.10",
  "company-details-service-types": "/company-details-service-types/static-1.2782",
  "final-form": "/final-form/static-1.40",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2851",
  "ContentUtils": "/ContentUtils/static-1.63533",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12108",
  "idb-keyval": "/idb-keyval/static-1.21",
  "magpie-types": "/magpie-types/static-1.3989",
  "simple-logging-lib": "/simple-logging-lib/static-1.1900",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3582",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3639",
  "FileManagerCore": "/FileManagerCore/static-1.34418",
  "FileManagerLib": "/FileManagerLib/static-1.34559",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3686",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "timezone-utils": "/timezone-utils/static-2.4103",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.9102",
  "react-dnd-compat": "/react-dnd-compat/static-1.3519",
  "apps-service-types": "/apps-service-types/static-1.2952",
  "oauth-service-types": "/oauth-service-types/static-1.3156",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5996",
  "nav-meta": "/nav-meta/static-1.25641",
  "react-window": "/react-window/static-1.13",
  "cms-field-types": "/cms-field-types/static-1.3651",
  "content-icons-ui": "/content-icons-ui/static-1.1917",
  "underscore": "/underscore/static-1.8",
  "audio-components": "/audio-components/static-1.4524",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.18918",
  "FileManagerImages": "/FileManagerImages/static-1.32069",
  "urlinator": "/urlinator/static-1.3412",
  "video-components": "/video-components/static-1.8191",
  "video-data-lib": "/video-data-lib/static-1.29840",
  "video-embed": "/video-embed/static-1.30680",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "content-assistance-lib": "/content-assistance-lib/static-1.6366",
  "media-bridge-lib": "/media-bridge-lib/static-1.16811",
  "immerable": "/immerable/static-1.3010",
  "social-insights-client-types": "/social-insights-client-types/static-1.17945",
  "outpost": "/outpost/static-1.3217",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.23294"
}
};
